module.exports = __webpack_public_path__ + "static/media/resume.c9322435.jpg";